var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDocuments = function SvgDocuments(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 70 70"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2F68D1",
    fillRule: "evenodd",
    d: "M14 2.449a2 2 0 0 0-2 2v.983h3.293a1.5 1.5 0 1 1 0 3H12v8.207h3.293a1.5 1.5 0 1 1 0 3H12v8.207h3.293a1.5 1.5 0 1 1 0 3H12v8.206h3.293a1.5 1.5 0 1 1 0 3H12v8.207h3.293a1.5 1.5 0 1 1 0 3H12v8.207h3.293a1.5 1.5 0 1 1 0 3H12v.983a2 2 0 0 0 2 2h41a2 2 0 0 0 2-2v-61a2 2 0 0 0-2-2zm8.78 7.845a2 2 0 0 0-2 2v1.603a2 2 0 0 0 2 2h23.44a2 2 0 0 0 2-2v-1.603a2 2 0 0 0-2-2z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF9D43",
    fillRule: "evenodd",
    d: "M12 5.439H8.122a1.5 1.5 0 1 0 0 3H12zm0 11.224H8.122a1.5 1.5 0 1 0 0 3H12zm0 11.225H8.122a1.5 1.5 0 1 0 0 3H12zm0 11.224H8.122a1.5 1.5 0 1 0 0 3H12zm0 11.225H8.122a1.5 1.5 0 0 0 0 3H12zm0 11.224H8.122a1.5 1.5 0 0 0 0 3H12z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#6C9BF1",
    d: "M57 11h2a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#B4CFFF",
    d: "M57 51h2a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF9D43",
    d: "M57 24h2a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD2A8",
    d: "M57 38h2a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2z"
  })));
};
export default SvgDocuments;